export const REGIONS = {
  ams: { name: 'Amsterdam', country: 'Netherlands', lat: 52.37, lng: 4.89 },
  cdg: { name: 'Paris', country: 'France', lat: 48.86, lng: 2.35 },
  dfw: { name: 'Dallas', country: 'USA', lat: 32.78, lng: -96.8 },
  ewr: { name: 'Newark', country: 'USA', lat: 40.69, lng: -74.17 },
  fra: { name: 'Frankfurt', country: 'Germany', lat: 50.11, lng: 8.68 },
  gru: { name: 'São Paulo', country: 'Brazil', lat: -23.55, lng: -46.63 },
  hkg: { name: 'Hong Kong', country: 'Hong Kong', lat: 22.32, lng: 114.17 },
  iad: { name: 'Virginia', country: 'USA', lat: 38.95, lng: -77.45 },
  lax: { name: 'Los Angeles', country: 'USA', lat: 33.94, lng: -118.41 },
  lhr: { name: 'London', country: 'UK', lat: 51.47, lng: -0.45 },
  nrt: { name: 'Tokyo', country: 'Japan', lat: 35.77, lng: 140.39 },
  ord: { name: 'Chicago', country: 'USA', lat: 41.97, lng: -87.9 },
  sea: { name: 'Seattle', country: 'USA', lat: 47.45, lng: -122.31 },
  sin: { name: 'Singapore', country: 'Singapore', lat: 1.35, lng: 103.99 },
  sjc: { name: 'San Jose', country: 'USA', lat: 37.36, lng: -121.93 },
  syd: { name: 'Sydney', country: 'Australia', lat: -33.95, lng: 151.18 },
  yyz: { name: 'Toronto', country: 'Canada', lat: 43.68, lng: -79.63 },
} as const;

export type Region = keyof typeof REGIONS;

export const DEFAULT_REGION: Region = 'iad';

export interface GeoLocation {
  lat: number;
  lng: number;
  city?: string;
  country?: string;
}

function haversineDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number,
): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export function findNearestRegion(location: GeoLocation): Region {
  let nearestRegion: Region = DEFAULT_REGION;
  let minDistance = Infinity;

  for (const [region, data] of Object.entries(REGIONS)) {
    const distance = haversineDistance(
      location.lat,
      location.lng,
      data.lat,
      data.lng,
    );
    if (distance < minDistance) {
      minDistance = distance;
      nearestRegion = region as Region;
    }
  }

  return nearestRegion;
}

export function getRegionInfo(region: Region) {
  return REGIONS[region] || REGIONS[DEFAULT_REGION];
}

export function isValidRegion(region: string): region is Region {
  return region in REGIONS;
}
